import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative w-full min-h-[100svh] overflow-hidden scroll-mt-16 md:scroll-mt-20">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_90ef0a8af71baaf7af0995cfea615695_3ddaa4a9.jpg"
          alt="Notranjost lokala Guma Caffe Lounge Bar Gorišnica"
          title="Guma Caffe Lounge Bar — prijeten ambient v Zamušanih"
          className="w-full h-full object-cover object-center"
        />
        {/* Dark overlay for readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full min-h-[100svh] flex flex-col items-center justify-center text-center px-5 md:px-6 py-24 md:py-20">
        {/* Logo */}
        <img
          src="https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/d1b6ec71613fd44f076bb20c8764731b.png"
          alt="Guma Caffe Lounge Bar Gorišnica"
          title="Guma Caffe Lounge Bar — kava in prijeten ambient v Zamušanih"
          className={`w-64 md:w-[26rem] h-auto object-contain rounded-lg mb-6 md:mb-9 transition-all duration-700 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        />

        {/* Locality eyebrow */}
        <div
          className={`flex items-center justify-center gap-3 mb-5 md:mb-6 transition-all duration-700 delay-100 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <span className="h-px w-10 bg-foreground-50/40" aria-hidden="true"></span>
          <span className="text-[10px] md:text-[11px] font-semibold tracking-[0.3em] uppercase text-foreground-50/90 whitespace-nowrap">
            Zamušani · Gorišnica
          </span>
          <span className="h-px w-10 bg-foreground-50/40" aria-hidden="true"></span>
        </div>

        <h1 className={`text-[23px] md:text-4xl lg:text-[2.75rem] font-heading font-bold text-foreground-50 leading-tight max-w-2xl transition-all duration-700 delay-150 ${
          loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          Najboljša kava v regiji in prijeten ambient v srcu Zamušanov
        </h1>

        <div className={`flex flex-col sm:flex-row items-center gap-3 mt-8 md:mt-10 transition-all duration-700 delay-450 ${
          loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <button
            onClick={() => scrollTo('ponudba')}
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-md bg-primary-500 text-foreground-50 font-semibold text-sm hover:bg-primary-600 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-300 cursor-pointer"
          >
            Poglej ponudbo
            <i className="ri-arrow-down-line ml-2"></i>
          </button>
          <button
            onClick={() => scrollTo('kontakt')}
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-md border-2 border-foreground-50/70 text-foreground-50 font-semibold text-sm hover:bg-foreground-50/10 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-300 cursor-pointer"
          >
            Kontakt & Lokacija
            <i className="ri-map-pin-line ml-2"></i>
          </button>
        </div>

        {/* Scroll indicator */}
        <div className={`absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 transition-all duration-700 delay-700 ${
          loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}>
          <div className="flex flex-col items-center gap-2">
            <span className="text-[9px] font-semibold uppercase tracking-[0.3em] text-foreground-50/60">
              Pomakni se
            </span>
            <span className="w-px h-8 bg-gradient-to-b from-foreground-50/60 to-transparent"></span>
          </div>
        </div>
      </div>
    </section>
  );
}